import React from 'react';
import {Icon} from "semantic-ui-react";
import './Progress.css';

const Progress = (props) => {
    return (
        <div id={'progress'}>
            {
                props.flow.settings.map((value)=> {
                    let current = '';
                    if(props.flow.nextStep === value.id){
                        current = 'current ';
                    }

                    return (
                        <div className={current + `step ` + value.class_name}> </div>
                    )

                    /*
                    let check_icon = null;
                    let progress = document.getElementById('progress');
                    let step_class_name = 'step';
                    if(props.flow.history[index+1]){
                        check_icon = <div className={'border'}><Icon name='check' /></div>;
                    }
                    if(props.flow.settings[value].name === 'Contact'){
                        step_class_name = 'step last';
                        progress.classList.add("last");
                    }
                    return (
                        <div className={step_class_name} onClick={() => {props.scrollToStep(value)}}>
                            {check_icon}
                            <Icon name={props.flow.settings[value].icon} size='big' />
                            <h4>{props.flow.settings[value].name}</h4>
                        </div>
                    )

                    */
                })
            }
        </div>
    );
};

export default Progress;